import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { getRelatedJobs } from "../../redux/actions/certificateVerification";

const RolesQualified = () => {
  const [roles, setRoles] = useState([]);
  const [sliderKey, setSliderKey] = useState(0); // Force re-render
  const sliderRef = useRef(null);
  const dispatch = useDispatch();
  const certificateData = useSelector((store)=>store?.certificateVerification?.certificateData);

  useEffect(()=>{
    if(certificateData?.certificate_name){
      dispatch(getRelatedJobs(certificateData?.certificate_name , (successObj)=>{
        setRoles(successObj?.data);
        // Force slider to re-initialize after data loads
        setTimeout(() => {
          setSliderKey(prev => prev + 1);
          if (sliderRef.current) {
            sliderRef.current.slickGoTo(0);
          }
        }, 100);
      } , (errorObj)=>{}))
    }
  },[certificateData?.certificate_name, dispatch])

  const settings = {
    dots: false,
    slidesToShow: 3.4,
    rows: 1,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    swipeToSlide:false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.2,
          autoplay: true,
          autoplaySpeed: 2000,
          easing: "linear",
          cssEase: "linear",
          infinite: true,
          dots: false,
          arrows: false,
          swipeToSlide: false,
        },
      },
    ],
  };

  // Don't render slider until we have data
  if (!roles || roles.length === 0) {
    return (
      <div className="w-full h-20 flex items-center justify-center">
        <div className="text-white/50 text-sm">Loading roles...</div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <Slider key={sliderKey} ref={sliderRef} {...settings}>
        {roles?.map((item, dx) => (
          <div key={dx} className="cursor-pointer">
            <div
              className="flex w-[96%] flex-col items-start justify-start rounded-lg py-2 px-3 leading-none"
              style={{
                backgroundImage: `linear-gradient(to bottom, #1A4993 0%, #1C385D 100%)`,
              }}
            >
              <img
                width={14}
                height={14}
                className="h-[14px] w-[14px]"
                src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Role.png?updatedAt=1750743767286"
                alt=""
              />
              <div className="mt-3 text-[12px] md:text-[14px] text-white line-clamp-1 ">
                {item?.job_name}
              </div>
              <div className="mt-3 flex items-end justify-start gap-1">
                <div className="text-[10px] md:text-[12px] text-white/50">Role Match:</div>
                <div className="flex items-end justify-start gap-1 mb-[2px] ">
                  {[true, true, false, false, false]?.map((subItem, index) => (
                    <div
                      key={index}
                      className={`h-[8px] w-[8px] bg-[#2BBD13] ${
                      (index < (Math.floor(item?.match_percentage/20))) ? "opacity-100" :  "opacity-20"
                      } `}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RolesQualified;